import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';
import { AddNetworkAdditionComponent } from '../add-network-addition/add-network-addition.component';

@Component({
  selector: 'app-network-addition',
  templateUrl: './network-addition.component.html',
  styleUrls: ['./network-addition.component.scss']
})
export class NetworkAdditionComponent implements OnInit {
  @Output() refreshTableData = new EventEmitter();
  networkAdditionFform: FormGroup;
  hpmnCountry:any;
  vpmnCountryList:any;
  selectedVPMNOrgId: string = "";
  showTable:boolean=false;
  tableData:any;
  selectedVpmnNetwork:any;
  vpmnNetworkyList: any;
  vpmnNetworkList: any[] = [];
  selectedRoamOrgId: any;



  constructor(private spinnerService: Ng4LoadingSpinnerService,
    private formBuilder: FormBuilder, private router: Router,
    private endpointsService: EndpointsService, private dialog: MatDialog,
    private backendApiService: BackendApiService) { }

  ngOnInit(): void {
    this.networkAdditionForm();
    // this.hpmnCountry = sessionStorage.getItem('homeCountry');
    this.hpmnCountry = "South Africa"
    console.log(">>>>>>>>>",this.hpmnCountry);
    this.getVPMNCountryDetails();
  }
  networkAdditionForm() {
    this.networkAdditionFform = this.formBuilder.group({
      hpmnCountry: ['South Africa'],
      VPMNCountry:[''],
      vpmnNetwork: [''],
    
    });
  }
  async getVPMNCountryDetails() {
    this.spinnerService.show();
    const apiUrl = this.endpointsService.URL_COUNTRY_FOR_NETWORK_ADDITION 
    this.backendApiService.callToApi(apiUrl).subscribe(response => {
      this.vpmnCountryList = response.countries 
      console.log("VPMN Country List:", this.vpmnCountryList);
      this.spinnerService.hide();
    });
  }
  // onVPMNNetworkChange(selectedCountry: string) {
  //   const selectedItem = this.vpmnCountryList.find(item => item.visitingCountry === selectedCountry);
  //   this.selectedVpmnNetwork = selectedItem ? selectedItem.visitingNetwork:"";
  //   this.selectedVPMNOrgId = selectedItem ? selectedItem.vistingOrgId : "";
  //   console.log("Selected Org ID:", this.selectedVPMNOrgId);
  //   console.log("Selected network:", this.selectedVpmnNetwork);
  // }

onVPMNNetworkChange(selectedCountry: string): void {
  if (!selectedCountry) {
    this.vpmnNetworkList = [];
    return;
  }

  const orgId = '6108'; // Replace with dynamic value if needed
  const encodedCountry = encodeURIComponent(selectedCountry);
  const apiUrl = `${this.endpointsService.URL_GET_NETWORK_FOR_SELECTED_COUNTRY}&orgId=${orgId}&visitingCountry=${encodedCountry}`;

  this.spinnerService.show();
  this.backendApiService.callToApi(apiUrl).subscribe(
    (response: any[]) => {
      this.vpmnNetworkList = response || [];
      console.log('Visiting Networks:', this.vpmnNetworkList);
      this.spinnerService.hide();
    },
    error => {
      console.error('Error fetching visiting networks', error);
      this.vpmnNetworkList = [];
      this.spinnerService.hide();
    }
  );
}




onNetworkSelected(selectedNetwork: string): void {
  const networkObj = this.vpmnNetworkList.find(item => item.vistingNetwork === selectedNetwork);
  if (networkObj) {
    this.selectedRoamOrgId = networkObj.roamOrgId;
    console.log('Selected Roam Org ID:', this.selectedRoamOrgId);
  } else {
    this.selectedRoamOrgId = '';
  }
}


// onVPMNNetworkChange(selectedCountry: string) {
//   console.log("Original Country Selected:", selectedCountry);

//   const orgId = 6108;
//   const countryWithoutSpaces = selectedCountry.replace(/\s+/g, '');
//   const encodedCountry = encodeURIComponent(countryWithoutSpaces);
//   const apiUrl = `http://54.68.219.97:8380/ECOWAS/EcowasBusinessServlet?reportType=getVistingOrgIds&orgId=${orgId}&visitingCountry=${encodedCountry}`;

//   this.spinnerService.show();
//   this.backendApiService.callToApi(apiUrl).subscribe(
//     (response) => {
//       if (response && response.length > 0) {
//         const visitingNetwork = response[0].vistingNetwork;
//         this.selectedVpmnNetwork = visitingNetwork;
//         console.log("Visiting Network:", this.selectedVpmnNetwork);

//         // Update form control as well
//         this.networkAdditionFform.get('vpmnNetwork')?.setValue(visitingNetwork);
//       } else {
//         this.selectedVpmnNetwork = '';
//         this.networkAdditionFform.get('vpmnNetwork')?.setValue('');
//       }

//       this.spinnerService.hide();
//     },
//     (error) => {
//       console.error("Error fetching org IDs:", error);
//       this.spinnerService.hide();
//     }
//   );
// }


  onSearch(){
this.spinnerService.show();
const roamOrgIdParam = this.selectedRoamOrgId ? this.selectedRoamOrgId : '';
const apiUrl = this.endpointsService.URL_GET_NETWORK_ADDITION +
    '&orgId=' + '6108' +'&roamOrgId=' + roamOrgIdParam

  this.backendApiService.callToApi(apiUrl).subscribe(res=>{
    console.log("response",res);
    this.tableData=res;
    this.showTable=true;
  })
  }
  onAdd(){
     const dialogRef = this.dialog.open(AddNetworkAdditionComponent, {
          width: '900px',
          panelClass: 'custom-modalbox',
          disableClose: true
        });
    
        dialogRef.afterClosed().subscribe(result => {
          if (result === "Created") {
            this.onSearch();
          }
        });
  }

  // onAdd(){
  //   this.router.navigate(['service-live-dashboard/add-sms-pdp-live-service'])
  // }
  onReset(){
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
   // this.storeAnalytics1();
  }

}
